// Spec It Out theme — mobile menu + legacy Casper burger
(function() {
    function initMobileMenu() {
        var header = document.getElementById('sio-header');
        var toggle = document.querySelector('[data-sio-menu-toggle]');
        var nav = document.getElementById('sio-nav');

        if (!toggle || !header || !nav) {
            return;
        }

        function setOpen(isOpen) {
            header.classList.toggle('sio-header--open', isOpen);
            toggle.setAttribute('aria-expanded', String(isOpen));
            document.body.classList.toggle('sio-nav-open', isOpen);
        }

        function closeMenu() {
            setOpen(false);
        }

        toggle.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            setOpen(!header.classList.contains('sio-header--open'));
        });

        nav.querySelectorAll('a').forEach(function(link) {
            link.addEventListener('click', closeMenu);
        });

        document.addEventListener('click', function(event) {
            if (!header.classList.contains('sio-header--open')) {
                return;
            }
            if (!header.contains(event.target)) {
                closeMenu();
            }
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                closeMenu();
            }
        });

        window.matchMedia('(min-width: 768px)').addEventListener('change', function(mq) {
            if (mq.matches) {
                closeMenu();
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMobileMenu);
    } else {
        initMobileMenu();
    }

    var burger = document.querySelector('.gh-burger');
    if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.addEventListener('click', function() {
            var isOpen = document.body.classList.toggle('gh-head-open');
            burger.setAttribute('aria-expanded', String(isOpen));
        });
    }
})();
